import {
  SET_CALL_CENTER_READY,
  SET_CALL_CENTER_CONTROL_NUMBER,
} from "typeConstants";
import { schedulingAssistant as initialState } from "../initialState.tsx";

const schedulingAssistant = (state = initialState, action) => {
  switch (action.type) {
    case SET_CALL_CENTER_READY:
      return {
        ...state,
        callCenterReady: action.payload
      };
    case SET_CALL_CENTER_CONTROL_NUMBER:   
      return {
        ...state,
        currentControlNumber: action.payload
      };        
    default:
      return state;
  }
};

export default schedulingAssistant;